/* styled-components & other non-external style-related exports (like, say, a `headerHeight` var) go here */
import { colors, font, ScaleAnimation, spacing, visuallyHiddenCss } from '@chegg-ui/theme';
import styled, { css } from 'styled-components';

var deriveFontSizeFromButtonSize = function deriveFontSizeFromButtonSize(size) {
  switch (size) {
    case 'large':
      return font.size.px24;

    case 'xsmall':
      return font.size.px16;

    case 'small':
    case 'medium':
    default:
      return font.size.px20;
  }
};

var derivePaddingFromButtonSize = function derivePaddingFromButtonSize(size) {
  switch (size) {
    case 'large':
      return "".concat(10 / 16, "rem ").concat(14 / 16, "rem");

    case 'small':
      return "".concat(4 / 16, "rem ").concat(14 / 16, "rem");

    case 'xsmall':
      return "".concat(2 / 16, "rem ").concat(10 / 16, "rem");

    case 'medium':
    default:
      return "".concat(spacing.px8, " ").concat(14 / 16, "rem");
  }
}; // we ensure the button fills the minimum recommended tap area, 42px
// https://uxmovement.com/mobile/optimal-size-and-spacing-for-mobile-buttons/


export var deriveIconButtonPaddingFromButtonSize = function deriveIconButtonPaddingFromButtonSize(size) {
  switch (size) {
    case 'large':
      return '0';

    case 'small':
      return "".concat(9 / 16, "rem");

    case 'xsmall':
      return "".concat(13 / 16, "rem");

    case 'medium':
    default:
      return "".concat(5 / 16, "rem");
  }
};
export var ButtonContentWrapper = styled.span.withConfig({
  componentId: "sc-1eq90u-0"
})(["display:flex;flex-direction:column;font-size:inherit;"]);
export var ButtonContent = styled.span.withConfig({
  componentId: "sc-1eq90u-1"
})(["align-items:center;display:inline-flex;font-size:inherit;justify-content:center;white-space:nowrap;visibility:", ";height:", ";overflow:", ";"], function (_ref) {
  var isVisible = _ref.isVisible;
  return isVisible ? 'visible' : 'hidden';
}, function (_ref2) {
  var isVisible = _ref2.isVisible,
      size = _ref2.size;
  return isVisible ? deriveFontSizeFromButtonSize(size) : '0';
}, function (_ref3) {
  var isVisible = _ref3.isVisible;
  return isVisible ? 'visible' : 'hidden';
});
export var LoadingText = styled.span.withConfig({
  componentId: "sc-1eq90u-2"
})(["margin-right:", "rem;font-size:inherit;"], 8 / 16);
var hoverAnimation = css([":hover{", " & > span:first-of-type{", "}}:not(:hover),:active{", " & > span:first-of-type{", "}}"], ScaleAnimation(), ScaleAnimation({
  scaleTarget: '0.95'
}), ScaleAnimation({
  scaleTarget: '1'
}), ScaleAnimation({
  scaleTarget: '1'
}));
export var ButtonContainer = styled.button.withConfig({
  componentId: "sc-1eq90u-3"
})(["align-items:center;border-radius:2rem;display:inline-flex;justify-content:center;font-family:", ";font-weight:", ";font-size:", ";padding:", ";border:2px solid ", ";line-height:1;margin:0;overflow:visible;text-transform:none;-webkit-appearance:button;cursor:pointer;:disabled{cursor:default;}"], font.family["default"], font.weight.bold, function (_ref4) {
  var size = _ref4.size;
  return deriveFontSizeFromButtonSize(size);
}, function (_ref5) {
  var size = _ref5.size;
  return derivePaddingFromButtonSize(size);
}, colors.transparent);
export var PrimaryButtonContainer = styled(ButtonContainer).withConfig({
  componentId: "sc-1eq90u-4"
})(["border-color:", ";background-color:", ";color:", ";", " ", ""], colors.cheggOrange, colors.cheggOrange, colors.white, function (_ref6) {
  var isLoading = _ref6.isLoading,
      disabled = _ref6.disabled;
  return isLoading || disabled ? "\n      border-color: ".concat(colors.greyXlight, ";\n      background-color: ").concat(colors.greyXlight, ";\n      color: ").concat(colors.grey, ";\n      cursor: default;\n      ") : "\n      :hover,\n      :active {\n        border-color: ".concat(colors.orangeDark, ";\n        background-color: ").concat(colors.orangeDark, ";\n        color: ").concat(colors.white, ";\n      }\n  ");
}, function (_ref7) {
  var disableHoverAnimation = _ref7.disableHoverAnimation,
      isLoading = _ref7.isLoading,
      disabled = _ref7.disabled;
  return disableHoverAnimation || isLoading || disabled ? '' : hoverAnimation;
});
export var OutlineButtonContainer = styled(ButtonContainer).withConfig({
  componentId: "sc-1eq90u-5"
})(["background-color:transparent;", " ", " ", ""], function (_ref8) {
  var size = _ref8.size;
  return size === 'xsmall' ? "\n      color: ".concat(colors.dark, ";\n      border-color: ").concat(colors.greyMedium, ";\n      ") : "\n      color: ".concat(colors.cheggOrange, ";\n      border-color: ").concat(colors.cheggOrange, ";\n  ");
}, function (_ref9) {
  var isLoading = _ref9.isLoading,
      disabled = _ref9.disabled,
      size = _ref9.size;
  return isLoading || disabled ? "\n      color: ".concat(colors.grey, ";\n      border-color: ").concat(colors.greyXlight, ";\n      cursor: default;\n      ") : "\n      :hover,\n      :active {\n        ".concat(size === 'xsmall' ? "\n          box-shadow: 0 0 0 2px ".concat(colors.greyMedium, ";\n          background-color: ").concat(colors.white, ";\n          border-color: ").concat(colors.greyMedium, ";\n          color: ").concat(colors.dark, ";\n        ") : "\n          background-color: ".concat(colors.orangeDark, ";\n          color: ").concat(colors.white, ";\n          border-color: ").concat(colors.orangeDark, ";\n        "), "\n      }\n      :active {\n        box-shadow: none;\n      }\n  ");
}, function (_ref10) {
  var disableHoverAnimation = _ref10.disableHoverAnimation,
      isLoading = _ref10.isLoading,
      disabled = _ref10.disabled;
  return disableHoverAnimation || isLoading || disabled ? '' : hoverAnimation;
});
export var ReverseButtonContainer = styled(ButtonContainer).withConfig({
  componentId: "sc-1eq90u-6"
})(["color:", ";border-color:", ";background-color:", ";", " ", ""], colors.dark, colors.white, colors.white, function (_ref11) {
  var isLoading = _ref11.isLoading,
      disabled = _ref11.disabled;
  return isLoading || disabled ? "\n      color: ".concat(colors.grey, ";\n      background-color: ").concat(colors.greyXlight, ";\n      border-color: ").concat(colors.greyXlight, ";\n      cursor: default;\n    ") : "\n      :hover, :active {\n        background-color: ".concat(colors.greyLight, ";\n        border-color: ").concat(colors.greyLight, ";\n      }\n    ");
}, function (_ref12) {
  var disableHoverAnimation = _ref12.disableHoverAnimation,
      isLoading = _ref12.isLoading,
      disabled = _ref12.disabled;
  return disableHoverAnimation || isLoading || disabled ? '' : hoverAnimation;
});
export var SecondaryButtonContainer = styled(ButtonContainer).withConfig({
  componentId: "sc-1eq90u-7"
})(["", " background-color:transparent;"], function (_ref13) {
  var isLoading = _ref13.isLoading,
      disabled = _ref13.disabled;
  return isLoading || disabled ? "\n    color: ".concat(colors.tealMedium, ";\n    cursor: default;\n    &:focus,\n    &:hover,\n    &:active {\n      text-decoration: none;\n    }\n    ") : "\n    color: ".concat(colors.link, ";\n    &:focus,\n    &:hover,\n    &:active {\n      text-decoration: underline;\n    }\n  ");
});
export var IconButtonContainer = styled(ButtonContainer).withConfig({
  componentId: "sc-1eq90u-8"
})(["background:transparent;border:0;padding:", ";", ""], function (_ref14) {
  var size = _ref14.size;
  return deriveIconButtonPaddingFromButtonSize(size);
}, function (_ref15) {
  var disableHoverAnimation = _ref15.disableHoverAnimation,
      disabled = _ref15.disabled;
  return disableHoverAnimation || disabled ? '' : hoverAnimation;
});
export var VisuallyHidden = styled.span.withConfig({
  componentId: "sc-1eq90u-9"
})(["", ""], visuallyHiddenCss);
export var ActionButtonContainer = styled(ButtonContainer).withConfig({
  componentId: "sc-1eq90u-10"
})(["background-color:transparent;border-color:", ";", " ", ""], colors.greyLight, function (_ref16) {
  var width = _ref16.width;
  return "width: ".concat(width, ";");
}, function (_ref17) {
  var isLoading = _ref17.isLoading,
      disabled = _ref17.disabled;
  return isLoading || disabled ? "\n    color: ".concat(colors.tealMedium, ";\n    cursor: default;\n    &:focus,\n    &:hover,\n    &:active {\n      text-decoration: none;\n    }\n    ") : "\n    color: ".concat(colors.link, ";\n    &:focus,\n    &:hover,\n    &:active {\n      text-decoration: underline;\n      border-color: ").concat(colors.grey, ";\n    }\n  ");
});
export var CourseButtonContainer = styled(ButtonContainer).withConfig({
  componentId: "sc-1eq90u-11"
})(["color:", ";border-color:", ";background-color:", ";box-shadow:0 0 16px rgba(34,34,34,0.2);", " ", ""], colors.dark, colors.white, colors.white, function (_ref18) {
  var width = _ref18.width;
  return "width: ".concat(width, ";");
}, function (_ref19) {
  var isLoading = _ref19.isLoading,
      disabled = _ref19.disabled;
  return isLoading || disabled ? "\n      color: ".concat(colors.greyMedium, ";\n      border-color: ").concat(colors.greyLight, ";\n      cursor: default;\n      box-shadow: none;\n    ") : "\n      :hover, :active {\n        &:hover {\n          box-shadow: 0 0 16px rgba(34, 34, 34, 0.5);\n        }\n      }\n    ";
});